import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatExpansionModule } from '@angular/material/expansion';
import { TranslateModule } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { ContentDataService } from '@pages/info-center/services/content-data.service';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  imports: [CommonModule, MatExpansionModule, TranslateModule],
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.scss',
})
export class PrivacyPolicyComponent implements OnInit, OnDestroy {

  panelOpenState = false;
  privacyPolicy: any[] = [];
  mainContent: any;
  isSkeletonMainContent = true;

  private readonly isBrowser: boolean;
  private readonly destroy$ = new Subject<void>();

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private contentDataService: ContentDataService,
    private sanitizer: DomSanitizer,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    this.contentDataService.getPrivacyPolicy()
      .pipe(takeUntil(this.destroy$))
      .subscribe(res => {
        this.privacyPolicy = res?.contents?.rows ?? [];
        this.mainContent = res?.main_description;
        this.isSkeletonMainContent = false;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  scroll(id: string | number): void {
    if (!this.isBrowser) return;
    const el = document.getElementById(String(id));
    el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  sanitize(content: string) {
    return this.sanitizer.bypassSecurityTrustHtml(content ?? '');
  }
}
